import Plate from 'pages/Blog/Article/UI/Plate/Plate';
import './TextBlock.scss';

export default function TextBlock({ children }) {
  return (
    <Plate >
      {children}
    </Plate>
  )
};